import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import InlineDialog from '@atlaskit/inline-dialog';
import IconForType from '../IconForType';
import { ButtonContents, Root, Text, Title } from './styledInlineMessage';

var InlineMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(InlineMessage, _React$Component);

  var _super = _createSuper(InlineMessage);

  function InlineMessage() {
    var _this;

    _classCallCheck(this, InlineMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDialog", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    return _this;
  }

  _createClass(InlineMessage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          placement = _this$props.placement,
          secondaryText = _this$props.secondaryText,
          title = _this$props.title,
          type = _this$props.type,
          testId = _this$props.testId;
      var _this$state = this.state,
          isHovered = _this$state.isHovered,
          isOpen = _this$state.isOpen;
      return /*#__PURE__*/React.createElement(Root, {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        appearance: type,
        "data-testid": testId
      }, /*#__PURE__*/React.createElement(InlineDialog, {
        onClose: function onClose() {
          _this2.setState({
            isOpen: false
          });
        },
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && "".concat(testId, "--inline-dialog")
      }, /*#__PURE__*/React.createElement(Button, {
        appearance: "subtle-link",
        onClick: this.toggleDialog,
        spacing: "none",
        testId: testId && "".concat(testId, "--button")
      }, /*#__PURE__*/React.createElement(ButtonContents, {
        isHovered: isHovered
      }, /*#__PURE__*/React.createElement(IconForType, {
        type: type,
        isHovered: isHovered,
        isOpen: isOpen
      }), title ? /*#__PURE__*/React.createElement(Title, {
        "data-testid": testId && "".concat(testId, "--title"),
        isHovered: isHovered
      }, title) : null, secondaryText ? /*#__PURE__*/React.createElement(Text, {
        "data-testid": testId && "".concat(testId, "--text"),
        isHovered: isHovered
      }, secondaryText) : null))));
    }
  }]);

  return InlineMessage;
}(React.Component);

_defineProperty(InlineMessage, "defaultProps", {
  children: null,
  placement: 'bottom-start',
  secondaryText: '',
  title: '',
  type: 'connectivity'
});

export { InlineMessage as default };